<template>
	<div class="grid p-fluid">
		<div class="col-12 md:col-8 sm:col-12">
			<div class="card">
				<h4>Detalle de Suscripción</h4>
				<!-- Sin ningún plan (clientes de siempre sin ServicePlan): antes la página no cargaba (H43). -->
				<div v-if="this.noPlan" class="trial-banner">
					<div class="trial-banner-text">
						<h5><i class="pi pi-info-circle" style="margin-right: 6px;"></i>Sin plan activo</h5>
						<p>Elige un plan para seguir emitiendo comprobantes electrónicos.</p>
					</div>
					<Button label="Elegir plan" icon="pi pi-check" class="p-button-rounded mr-2 mb-2 renew-button" @click="openRenewal()" />
				</div>
				<!-- Período de prueba (toda alta nace como trial de 14 días; se paga luego para activar) -->
				<div v-if="this.currentSubscription.isTrial" class="trial-banner">
					<div class="trial-banner-text">
						<h5><i class="pi pi-clock" style="margin-right: 6px;"></i>Estás en período de prueba</h5>
						<p>{{ (this.currentSubscription.remainingDays > 0)
							? ('Te quedan ' + this.currentSubscription.remainingDays + (this.currentSubscription.remainingDays === 1 ? ' día' : ' días') + ' de prueba de tu plan ' + (this.currentSubscription.planName || '') + '.')
							: 'Tu período de prueba ha finalizado.' }} Activa tu suscripción para seguir facturando.</p>
					</div>
					<Button label="Activar mi plan" icon="pi pi-check" class="p-button-rounded mr-2 mb-2 renew-button" @click="openRenewal()" />
				</div>
				<!-- For computer -->
				<div class="grid" id="pcSubscriptionContainer" v-if="!this.noPlan">
					<div class="col-4 flex flex-column align-items-center justify-content-center">
						<img v-if="this.currentSubscription.plan && this.currentSubscription.plan.imageUrl" :src="this.baseUrl + this.currentSubscription.plan.imageUrl" alt="Tipo de suscripción" style="width: 100%; margin: 11px 0px;">
						<h4 style="text-align: center; color: #18407F; margin: 8px 0px;">{{ this.currentSubscription.planName || 'Plan' }}</h4>
					</div>
					<div class="col-1">
						<Divider layout="vertical">
						</Divider>
					</div>
					<div class="col-3 align-items-center justify-content-center">
						<div style="margin-bottom: 20px; text-align: center;">
							<h5>Inicio de suscripción</h5>
							<h6>{{ this.currentSubscription.createdAt }}</h6>
						</div>
						<div style="text-align: center;">
							<h5>Fin de suscripción</h5>
							<h6>{{ this.currentSubscription.goodThru }}</h6>
						</div>
						<div v-if="this.currentSubscription.canRenew">
							<h6 v-show="this.alert" class="alert" style="text-align: center; margin-top: 20px;">{{ this.alertMessage }}</h6>
							<!-- Siempre a mano: renovar antes del aviso deja el plan en cola (H43). -->
							<Button label="Renovar" class="p-button-rounded mr-2 mb-2 renew-button" @click="openRenewal()" />
						</div>
					</div>
					<div class="col-1">
						<Divider layout="vertical"></Divider>
					</div>
					<div class="col-3 align-items-center justify-content-center">
						<Chart type="doughnut" :data="pieData" style="width: 90%;"/>
						<h6 style="margin-top: 20px; text-align: center;" v-if="!this.currentSubscription.unlimitedDocs && this.currentSubscription.status == 'ACTIVE'">{{ this.currentSubscription.documents }} {{ (this.currentSubscription.documents == 1) ? "Documento electrónico disponible" : "Documentos electrónicos disponibles" }}</h6>
						<h6 style="margin-top: 20px; text-align: center;" v-if="this.currentSubscription.unlimitedDocs && this.currentSubscription.status == 'ACTIVE'">{{ "Documentos electrónicos ilimitados" }}</h6>
					</div>
				</div>

				<!-- For Mobile -->
				<div id="mobileSubscriptionContainer" v-if="!this.noPlan">
					<div class="col-12 flex flex-column align-items-center justify-content-center">
						<img v-if="this.currentSubscription.plan && this.currentSubscription.plan.imageUrl" :src="this.baseUrl + this.currentSubscription.plan.imageUrl" alt="Tipo de suscripción" style="width: 100%; margin: 11px 0px;">
						<h4 style="text-align: center; color: #18407F; margin: 8px 0px;">{{ this.currentSubscription.planName || 'Plan' }}</h4>
					</div>
					<div class="col-11">
						<Divider layout="horizontal">
						</Divider>
					</div>
					<div class="col-12 align-items-center justify-content-center">
						<Chart type="doughnut" :data="pieData" style="width: 90%;"/>
						<h6 style="margin-top: 20px; text-align: center;" v-if="!this.currentSubscription.unlimitedDocs">{{ this.currentSubscription.documents }} {{ (this.currentSubscription.documents == 1) ? "Documento electrónico disponible" : "Documentos electrónicos disponibles" }}</h6>
						<h6 style="margin-top: 20px; text-align: center;" v-if="this.currentSubscription.unlimitedDocs">{{ "Documentos electrónicos ilimitados" }}</h6>
					</div>
					<div class="col-11">
						<Divider layout="horizontal"></Divider>
					</div>
					<div class="col-12 align-items-center justify-content-center">
						<div style="margin-bottom: 20px; text-align: center;">
							<h5>Inicio de suscripción</h5>
							<h6>{{ this.currentSubscription.createdAt }}</h6>
						</div>
						<div style="text-align: center;">
							<h5>Fin de suscripción</h5>
							<h6>{{ this.currentSubscription.goodThru }}</h6>
						</div>
						<div v-if="this.currentSubscription.canRenew">
							<h6 v-show="this.alert" class="alert" style="text-align: center; margin-top: 20px;">{{ this.alertMessage }}</h6>
							<!-- Siempre a mano: renovar antes del aviso deja el plan en cola (H43). -->
							<Button label="Renovar" class="p-button-rounded mr-2 mb-2 renew-button" @click="openRenewal()" />
						</div>
					</div>
				</div>
			</div>
			<div class="card" v-if="this.currentSubscription.limits">
				<h5>Tu plan incluye</h5>
				<div class="grid" style="margin-top: 8px;">
					<div class="col-6 md:col-4 plan-limit"><label>Documentos</label><br>{{ this.currentSubscription.limitLabel('documentos', 'Ilimitados') }}<small v-if="this.currentSubscription.remainingLabel('documentos')" class="block" style="color:#666;">{{ this.currentSubscription.remainingLabel('documentos') }}</small></div>
					<div class="col-6 md:col-4 plan-limit"><label>Clientes</label><br>{{ this.currentSubscription.limitLabel('clientes', 'Ilimitados') }}<small v-if="this.currentSubscription.remainingLabel('clientes')" class="block" style="color:#666;">{{ this.currentSubscription.remainingLabel('clientes') }}</small></div>
					<div class="col-6 md:col-4 plan-limit"><label>Productos</label><br>{{ this.currentSubscription.limitLabel('productos', 'Ilimitados') }}<small v-if="this.currentSubscription.remainingLabel('productos')" class="block" style="color:#666;">{{ this.currentSubscription.remainingLabel('productos') }}</small></div>
					<div class="col-6 md:col-4 plan-limit"><label>Actividades económicas</label><br>{{ this.currentSubscription.limitLabel('actividades', 'Ilimitadas') }}<small v-if="this.currentSubscription.remainingLabel('actividades')" class="block" style="color:#666;">{{ this.currentSubscription.remainingLabel('actividades') }}</small></div>
					<div class="col-6 md:col-4 plan-limit"><label>Usuarios</label><br>{{ this.currentSubscription.limitLabel('usuarios', 'Ilimitados') }}</div>
				</div>
			</div>
			<div class="card">
				<h5>Registro de Suscripciones</h5>
				<DataView :value="this.subs"  layout="list" :rows="9">
					<template #list="slotProps">
						<div class="col-12">
							<div class="flex flex-column md:flex-row align-items-center p-3 w-full">
								<img v-if="slotProps.data.plan && slotProps.data.plan.imageUrl" :src="this.baseUrl + slotProps.data.plan.imageUrl" :alt="slotProps.data.planName" class="my-4 md:my-0 w-9 md:w-10rem shadow-2 mr-5" style="margin: auto;"/>
								<div class="flex-1 text-center md:text-left">
									<h6 style="color: #18407F; margin-bottom: 8px;">{{ slotProps.data.planName }}</h6>
									<div class="mb-3"><label style="font-size: 10px; color: black; font-weight: 500;">COMIENZA</label><br>{{ (slotProps.data.status !== "UNUSED") ? slotProps.data.createdAt : "Sin registro" }}</div>
									<div class="mb-3" style="margin-bottom: 0px; !important"><label style="font-size: 10px; color: black; font-weight: 500;">TERMINA</label><br>{{ (slotProps.data.status !== "UNUSED") ? slotProps.data.goodThru : "Sin registro" }}</div>
								</div>
								<div class="flex flex-row md:flex-column justify-content-between w-full md:w-auto align-items-center md:align-items-end mt-5 md:mt-0">
									<span :class="'status-badge status-' + slotProps.data.currentStatusBadgeColor" style="margin: auto;">{{slotProps.data.currentStatus}}</span>
								</div>
							</div>
						</div>
					</template>
				</DataView>
			</div>
		</div>
		<Dialog v-model:visible="renewSubDialog" ref="subscriptionDialog" :style="{'max-width': '900px', width: '90%'}" header="Renovar Suscripción" :modal="true" class="p-fluid">
			<h5><b>1)</b> Seleccione el tipo de suscripción</h5>
			<DataView :value="plans" layout="grid" :rows="9" style="width: 100%;">
				<template #grid="slotProps">
					<div class="col-12 md:col-6">
						<div class="card m-3 border-1 surface-border servicePlan" :class="{selected: slotProps.data.code === this.selectedPlan.code}" @click="onPlanSelected(slotProps.data)">
							<div class="text-center">
								<div class="flex align-items-center justify-content-center" style="gap: 8px; margin: 12px 0;">
									<h4 style="color: #18407F; margin: 0;">{{ slotProps.data.name }}</h4>
									<span v-if="slotProps.data.featured" class="status-badge status-orange">Recomendado</span>
								</div>
								<h5 style="margin: 0 0 12px;">${{ slotProps.data.price.toFixed(2) }} <span style="font-size: 12px; font-weight: 400;">/ año + IVA</span></h5>
								<ul style="text-align: left;">
									<li>{{ slotProps.data.limitLabel('actividades', 'Ilimitadas') }} {{ (slotProps.data.limits && slotProps.data.limits.actividades === 1) ? "Actividad Económica" : "Actividades Económicas" }}</li>
									<li>{{ slotProps.data.limitLabel('clientes', 'Ilimitados') }} registros de clientes</li>
									<li>{{ slotProps.data.limitLabel('productos', 'Ilimitados') }} registros de productos o servicios</li>
									<li>{{ slotProps.data.limitLabel('documentos', 'Ilimitados') }} Doc. Electrónicos</li>
									<li v-if="slotProps.data.limits && slotProps.data.limits.usuarios !== undefined">{{ slotProps.data.limitLabel('usuarios', 'Ilimitados') }} {{ (slotProps.data.limits && slotProps.data.limits.usuarios === 1) ? "usuario" : "usuarios" }}</li>
								</ul>
							</div>
						</div>
					</div>
				</template>
				<template #footer style="background-color: white;">
					<h4><b>Resumen:</b></h4>
					<h5 style="margin-top: 5px;">Suscripción Seleccionada: <b>{{ this.selectedPlan.name || '—' }}</b></h5>
					<h5 v-if="selectedExtras.length" style="margin-top: 5px;">Módulos extra: <b>{{ selectedExtras.map(e => e.name).join(', ') }}</b></h5>
					<h5 style="margin-top: 5px;">Duración de Suscripción: <b>1 año</b></h5>
					<h5 style="margin-top: 5px;">Total: <b>${{ renewalTotalWithTax !== null ? renewalTotalWithTax.toFixed(2) : '—' }}</b> <span style="font-weight: 400; font-size: 12px;">(IVA incluido)</span></h5>
				</template>
			</DataView>

			<!-- Agregar módulos al plan elegido (add-on "solo agregar"): se cobran aparte del plan. -->
			<div v-if="selectedPlan.id !== null && selectedPlan.extras && selectedPlan.extras.length" class="mb-3">
				<h5><b>Agrega módulos a tu plan</b> <span style="font-weight: 400; font-size: 12px;">(opcional · se suman al precio del plan)</span></h5>
				<div class="grid">
					<div class="col-12 md:col-6" v-for="ex in selectedPlan.extras" :key="ex.id">
						<!-- Contabilidad necesita el Kardex (del plan o como extra): hasta tenerlo queda deshabilitada (H13). -->
						<div class="p-3 m-2 border-1 surface-border border-round" style="display: flex; align-items: center;"
							:class="{'surface-100': selectedExtraIds.includes(ex.id), 'opacity-60': isExtraDisabled(ex)}"
							v-tooltip.top="isExtraDisabled(ex) ? accountingNeedsKardex : null">
							<InputSwitch :modelValue="selectedExtraIds.includes(ex.id)" :disabled="isExtraDisabled(ex)" @update:modelValue="toggleExtra(ex.id)" />
							<span style="margin-left: 10px;">{{ ex.name }}</span>
							<span style="margin-left: auto; font-weight: 600;">+${{ ex.price.toFixed(2) }}</span>
						</div>
					</div>
				</div>
			</div>
			<h5 ref="section2"><b>2)</b> Realize el pago de <b>${{ renewalTotalWithTax !== null ? renewalTotalWithTax.toFixed(2) : '—' }}</b> <span style="font-weight: 400; font-size: 12px;">(IVA incluido)</span> transfiriendo a una de las siguientes cuentas bancarias, después adjunte el comprobante en la sección inferior y haga click en Enviar</h5>
			<div class="grid p-fluid">
				<div class="col-12 md:col-6">
					<div class="card m-3 border-1 surface-border">
						<div class="text-center">
							<img src="/layout/images/payment/pichincha.png" class="w-9 my-3 mx-0"/>
						</div>
						<ul>
							<li><b>Cuenta de Ahorro: </b> 2203777977</li>
							<li><b>Titular: </b> Paul Estrada León</li>
							<li><b>Cédula: </b> 1310426174</li>
						</ul>
					</div>
				</div>
				<div class="col-12 md:col-6">
					<div class="card m-3 border-1 surface-border">
						<div class="text-center">
							<img src="/layout/images/payment/pacifico.jpeg" class="w-9 my-3 mx-0"/>
						</div>
						<ul>
							<li><b>Cuenta de Ahorro: </b> 1055322220</li>
							<li><b>Titular: </b> Paul Estrada León</li>
							<li><b>Cédula: </b> 1310426174</li>
						</ul>
					</div>
				</div>
				<div class="col-12 md:col-12">
					<FileUpload name="paymentProof" chooseLabel="Adjuntar comprobante" :fileLimit="1" :showUploadButton="false" :showCancelButton="false" accept="image/*" :maxFileSize="10000000" invalidFileLimitMessage="Solo puede seleccionar un comprobante." customUpload  @select="onPaymentProof($event)">
						<template #empty>
							<p>Arrastre el comprobante hasta aquí</p>
						</template>
					</FileUpload>
				</div>
				<div class="col-12 md:col-12">
					<Button label="Enviar" class="p-button-raised p-button-success mr-2 mb-2" @click="saveSubRenewal()" />
				</div>


				<Dialog header="Advertencia" v-model:visible="warningDialog" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
					<p class="line-height-3 m-0">
						{{ this.warningMessage }}
					</p>
					<template #footer>
						<Button label="Entendido" @click="this.warningDialog=false" icon="pi pi-check" class="p-button-outlined"/>
					</template>
				</Dialog>
			</div>
			
			<template #footer>
				<Button label="Cerrar" class="p-button-secondary mr-2 mb-2" style="margin-top: 15px;" @click="this.onSubscriptionDialogClosed()"/>
			</template>
		</Dialog>


		<Dialog header="Solicitud Enviada" v-model:visible="completionDialog" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true" :closable="false">
			<p class="line-height-3 m-0">
				Se ha enviado su solicitud de renovación y sera revisada dentro de las proximas 48 horas, por el momento su nueva suscripción esta pre-aprobada.<br> Muchas gracias por su preferencia.
			</p>
			<template #footer>
				<Button label="Entendido" @click="this.completionDialog=false" icon="pi pi-check" class="p-button-outlined"/>
			</template>
		</Dialog>
	</div>
</template>
<script>
	import httpRequest from '../../service/httpRequest';		
	import Subscription from '../../models/subscription';
	import CataloguePlan from '../../models/cataloguePlan';
	import { compressImage, IMAGE_MAX_BYTES } from '../../service/imageCompression';
	import { ACCOUNTING_NEEDS_KARDEX, extraDisabled, normalizeExtras } from '../../service/renewalExtras';

	export default {
		data() {
			return {
				baseUrl: this.$baseURL,
				accountingNeedsKardex: ACCOUNTING_NEEDS_KARDEX,
				noPlan: false,      // el negocio no tiene ningún plan (H43)
				alert: true,
				alertMessage: "",
				currentSubscription: new Subscription(),
				plans: null,
				selectedPlan: new CataloguePlan(),
				selectedExtraIds: [],   // módulos extra añadidos al plan (add-on "solo agregar")
				subs: null,
				selectedProof: null,
				renewSubDialog: false,
				warningDialog: false,
				warningMessage: "",
				completionDialog: false,
				pieData: {
					labels: [''],
					datasets: [
						{
							data: [0, 0],
							backgroundColor: [
								"#18407F",
								"#EEEDEF"
							],
							hoverBackgroundColor: [
								"#18407F",
								"#EEEDEF"
							]
						}
					]
				},
			}
		},
		async created() {
			this.getSubscriptions();
		},
		computed: {
			// Extras del plan seleccionado que el usuario marcó (add-on "solo agregar").
			selectedExtras() {
				const extras = (this.selectedPlan && this.selectedPlan.extras) || [];
				return extras.filter((e) => this.selectedExtraIds.includes(e.id));
			},
			// Total = precio del plan + solo los extras elegidos (sin IVA).
			renewalTotal() {
				const base = (this.selectedPlan && this.selectedPlan.price !== null) ? this.selectedPlan.price : null;
				if (base === null) { return null; }
				return base + this.selectedExtras.reduce((s, e) => s + (e.price || 0), 0);
			},
			// Total con IVA: lo calcula el backend (una sola tarifa, SUBSCRIPTION_IVA_RATE) para el
			// plan y para cada extra; aquí solo se suman.
			renewalTotalWithTax() {
				const base = (this.selectedPlan && this.selectedPlan.priceWithTax !== null && this.selectedPlan.priceWithTax !== undefined) ? this.selectedPlan.priceWithTax : null;
				if (base === null) { return null; }
				return base + this.selectedExtras.reduce((s, e) => s + (e.priceWithTax || 0), 0);
			},
		},
		methods: {
			async getSubscriptions() {
				const response = await httpRequest.getSubscriptions();
				if (response.status === 200) {
					this.handleSubsResponse(response.data);
				} 
			},
			async getPlans() {
				const response = await httpRequest.getPlanCatalogue();
				if (response.status === 200) {
					this.plans = response.data.map(p => { return new CataloguePlan(p) });
				}
			},
			openRenewal() {
				// CTA del banner de prueba: abre el diálogo de pago (transferencia + comprobante).
				this.getPlans();
				this.renewSubDialog = true;
			},
			onPlanSelected(plan) {
				this.selectedPlan = plan;
				this.selectedExtraIds = [];   // al cambiar de plan, se limpian los extras
				var element = this.$refs["section2"];
				element.scrollIntoView({behavior: 'smooth'});
			},
			toggleExtra(optId) {
				const ex = (this.selectedPlan.extras || []).find(e => e.id === optId);
				if (ex && this.isExtraDisabled(ex)) { return; }
				const i = this.selectedExtraIds.indexOf(optId);
				if (i > -1) { this.selectedExtraIds.splice(i, 1); }
				else { this.selectedExtraIds.push(optId); }
				// Sin Kardex, Contabilidad no puede quedar marcada (H13).
				this.selectedExtraIds = normalizeExtras(this.selectedPlan, this.selectedExtraIds);
			},
			isExtraDisabled(ex) {
				return extraDisabled(ex, this.selectedPlan, this.selectedExtraIds);
			},
			async onPaymentProof(event) {
				// Comprimimos la imagen en el cliente antes de enviarla para no
				// exceder el límite del backend/nginx (ver service/imageCompression.js).
				const original = event.files && event.files[0];
				if (!original) { this.selectedProof = null; return; }
				let file = original;
				try {
					file = await compressImage(original);
				} catch (e) {
					file = original;
				}
				if (file.size > IMAGE_MAX_BYTES) {
					this.selectedProof = null;
					this.warningMessage = "La imagen del comprobante es muy pesada. Intente con una captura de pantalla o una foto de menor resolución.";
					this.warningDialog = true;
					return;
				}
				this.selectedProof = file;
			},
			onSubscriptionDialogClosed() {
				this.selectedPlan = new CataloguePlan();
				this.selectedExtraIds = [];
				this.renewSubDialog = false;
			},
			async saveSubRenewal() {
				if (this.selectedPlan.id === null) { this.warningMessage = "Selecciona un plan antes de enviar la solicitud de renovación."; this.warningDialog = true; return }
				if (this.selectedProof === null) { this.warningMessage = "Adjunte un comprobante de la transferencia requerida antes de enviar la solicitud de renovación de Suscripción."; this.warningDialog = true; return }
				// Create form
				const form = new FormData();
				form.append(this.selectedPlan.renewalField, this.selectedPlan.id)
				// Módulos extra elegidos (unión de los módulos de cada extra): add-on "solo agregar".
				const extraModulos = [...new Set(this.selectedExtras.flatMap((e) => e.modules || []))];
				if (extraModulos.length) { form.append('extraModulos', JSON.stringify(extraModulos)) }
				if (this.selectedProof !== null) { form.append('proof', this.selectedProof) }

				// Send to server
				const response = await httpRequest.renewSubscription(form);
				if (response.status === 200) {
					this.renewSubDialog = false;
					this.completionDialog = true;
					this.handleSubsResponse(response.data);
				}
			},
			handleSubsResponse(data) {
				let subsData = data["subs"] || [];
				this.subs = subsData.map(data => { return new Subscription(data) });
				this.currentSubscription = new Subscription(data["current"]);
				this.noPlan = !data["current"];
				if (this.noPlan) {
					this.alert = false;
					this.getPlans();
					return;
				}
				let hasUnusedSub = this.subs.filter((sub) => sub.status == "UNUSED").length > 0;

				// Setup analytics and alert
				if (this.currentSubscription.status === "EXPIRED") { // Expirada desde la consola, aunque la fecha siga vigente (H41)
					this.alert = true;
					this.alertMessage = "Tu suscripción ha expirado, renueva para reestablecer tu cuenta."
					this.pieData.datasets[0].data = [0, 365]
					this.pieData.labels = ["Días restantes"]
					this.getPlans();
				} else if (hasUnusedSub) { // Has an unused subscription
					this.alert = false 
					const difference = (this.currentSubscription.remainingDays > 365) ? 0 : (365-this.currentSubscription.remainingDays)
					this.pieData.datasets[0].data = [this.currentSubscription.remainingDays, difference]
					this.pieData.labels = [this.currentSubscription.remainingDays + " días restantes"]
				} else if (this.currentSubscription.unlimitedDocs) { // Documentos ilimitados (antes: plan Empresarial)
					if (this.currentSubscription.remainingDays == 0) { 
						this.alert = true;
						this.alertMessage = "Tu suscripción expira mañana, renueva para evitar interrupciones."
						this.pieData.datasets[0].data = [0, 365]
						this.pieData.labels = ["Días restantes"]
						this.getPlans();
					} else if (this.currentSubscription.remainingDays < 0) { 
						this.alert = true;
						this.alertMessage = "Tu suscripción ha expirado, renueva para reestablecer tu cuenta."
						this.pieData.datasets[0].data = [0, 365]
						this.pieData.labels = ["Días restantes"]
						this.getPlans();
					} else if (this.currentSubscription.remainingDays <= 15) { // Warning on expire date
						this.alert = true;
						let dayStr = (this.currentSubscription.remainingDays == 1) ? "Queda 1 día" : "Quedan " + this.currentSubscription.remainingDays + " días"
						this.alertMessage = dayStr + " antes que tu suscripción expire"
						this.alertMessage += ". Sugerimos renovar pronto."
						this.pieData.datasets[0].data = [this.currentSubscription.remainingDays, (365-this.currentSubscription.remainingDays)]
						this.pieData.labels = [this.currentSubscription.remainingDays + " días restantes"]
						this.pieData.datasets[0].backgroundColor = ["#F7AB47", "#EEEDEF"]
						this.pieData.datasets[0].hoverBackgroundColor = ["#F7AB47", "#EEEDEF"]
						this.getPlans();
					} else { // Subscription has no issue
						this.alert = false 
						const difference = (this.currentSubscription.remainingDays > 365) ? 0 : (365-this.currentSubscription.remainingDays)
						this.pieData.datasets[0].data = [this.currentSubscription.remainingDays, difference]
						this.pieData.labels = [this.currentSubscription.remainingDays + " días restantes"]
					}
				} else { // Limited subscriptions
					if (this.currentSubscription.remainingDays == 0) { 
						this.alert = true;
						this.alertMessage = "Tu suscripción expira mañana, renueva para evitar interrupciones."
						this.pieData.datasets[0].data = [0, 365]
						this.pieData.labels = ["Días restantes"]
						this.getPlans();
					} else if (this.currentSubscription.remainingDays < 0) { // Expired
						this.alert = true;
						this.alertMessage = "Tu suscripción ha expirado, renueva para reestablecer tu cuenta."
						this.pieData.datasets[0].data = [0, 365]
						this.pieData.labels = ["Días restantes"]
						this.getPlans();
					} else if (this.currentSubscription.documents <= 0) { // No Documents
						this.alert = true;
						this.alertMessage = "Tus documentos electrónicos se han agotado, renueva para reestablecer tu cuenta."
						this.pieData.datasets[0].data = [this.currentSubscription.remainingDays, (365-this.currentSubscription.remainingDays)]
						this.pieData.labels = [this.currentSubscription.remainingDays + " días restantes"]
						this.pieData.datasets[0].backgroundColor = ["#F7AB47", "#EEEDEF"]
						this.pieData.datasets[0].hoverBackgroundColor = ["#F7AB47", "#EEEDEF"]
						this.getPlans();
					} else if (this.currentSubscription.remainingDays <= 15 && this.currentSubscription.documents <= 15) { // Warning on both no-documents and expire date
						this.alert = true;
						let dayStr = (this.currentSubscription.remainingDays == 1) ? "Queda 1 día" : "Quedan " + this.currentSubscription.remainingDays + " días"
						let docAmountStr = (this.currentSubscription.documents == 1) ? ", y cuentas con 1 doc. electrónico disponible" : ", y cuentas con " + this.currentSubscription.documents + " doc. electrónicos disponibles"
						this.alertMessage = dayStr + " antes que tu suscripción expire" + docAmountStr
						this.alertMessage += ". Sugerimos renovar pronto."

						this.pieData.datasets[0].data = [this.currentSubscription.remainingDays, (365-this.currentSubscription.remainingDays)]
						this.pieData.labels = [this.currentSubscription.remainingDays + " días restantes"]
						this.pieData.datasets[0].backgroundColor = ["#F7AB47", "#EEEDEF"]
						this.pieData.datasets[0].hoverBackgroundColor = ["#F7AB47", "#EEEDEF"]
						this.getPlans();
					} else if (this.currentSubscription.remainingDays <= 15) { // Warning on expire date
						this.alert = true;
						let dayStr = (this.currentSubscription.remainingDays == 1) ? "Queda 1 día" : "Quedan " + this.currentSubscription.remainingDays + " días"
						this.alertMessage = dayStr + " antes que tu suscripción expire"
						this.alertMessage += ". Sugerimos renovar pronto."
					
						this.pieData.datasets[0].data = [this.currentSubscription.remainingDays, (365-this.currentSubscription.remainingDays)]
						this.pieData.labels = [this.currentSubscription.remainingDays + " días restantes"]
						this.pieData.datasets[0].backgroundColor = ["#F7AB47", "#EEEDEF"]
						this.pieData.datasets[0].hoverBackgroundColor = ["#F7AB47", "#EEEDEF"]
						this.getPlans();
					} else if (this.currentSubscription.documents <= 15) { // Warning on no-documents
						this.alert = true;
						let docAmountStr = (this.currentSubscription.documents == 1) ? "1 documento electrónico" : this.currentSubscription.documents + " documentos electrónicos"
						this.alertMessage = "Cuentas con " + docAmountStr + ". Sugerimos renovar pronto."
					
						this.pieData.datasets[0].data = [this.currentSubscription.remainingDays, (365-this.currentSubscription.remainingDays)]
						this.pieData.labels = [this.currentSubscription.remainingDays + " días restantes"]
						this.pieData.datasets[0].backgroundColor = ["#F7AB47", "#EEEDEF"]
						this.pieData.datasets[0].hoverBackgroundColor = ["#F7AB47", "#EEEDEF"]
						this.getPlans();
					} else { // Current subscription has no issue
						this.alert = false;
						const difference = (this.currentSubscription.remainingDays > 365) ? 0 : (365-this.currentSubscription.remainingDays)
						this.pieData.datasets[0].data = [this.currentSubscription.remainingDays, difference]
						this.pieData.labels = [this.currentSubscription.remainingDays + " días restantes"]
					}
				}
			}
		}
	}
</script>
<style lang="scss">
	// @import './App.scss';
	@import '../../assets/demo/badges.scss';
	// #subscriptionDialog {
	// 	scroll-behavior: smooth;
	// }
	.alert {
		color: red;
		margin-top: 10px;
		padding: 0px;
	}
	.trial-banner {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
		flex-wrap: wrap;
		background: #FEEDAF;
		border: 1px solid #F7AB47;
		border-radius: var(--border-radius);
		padding: 12px 16px;
		margin-bottom: 16px;
	}
	.trial-banner .trial-banner-text h5 {
		margin: 0;
		color: #8A5340;
	}
	.trial-banner .trial-banner-text p {
		margin: 6px 0 0;
		color: #8A5340;
		font-size: 13px;
	}
	h5 {
		margin-bottom: 5px;
	}
	h6 {
		margin: 0px;
	}
	.plan-limit {
		text-align: center;
		margin-bottom: 8px;
	}
	.plan-limit label {
		font-size: 10px;
		color: black;
		font-weight: 500;
	}
	.middle-separator {
		border-left: 1px solid lightgray;
		border-right: 1px solid lightgray;
		text-align: center;
		padding-top: 20px;
	}
	.renew-button:hover {
		background: #f18700 !important;
		border: 1px solid #f18700 !important;
	}
	.status-badge {
		border-radius: var(--border-radius);
		padding: .25em .5rem;
		text-transform: uppercase;
		font-weight: 700;
		font-size: 12px;
		letter-spacing: .3px;
	}
	.servicePlan:hover {
		border: 2px solid #f18700 !important; 
	}
	.selected {
		border: 2px solid #f18700 !important; 
	}
	.status-badge {
		&.status-green {
			background: #C8E6C9;
			color: #256029;
		}

		&.status-red {
			background: #FFCDD2;
			color: #C63737;
		}

		&.status-yellow {
			background: #FEEDAF;
			color: #8A5340;
		}

		&.status-orange {
			background: #ffa177;
			color: #da2727;
		}

		&.status-blue {
			background: #B3E5FC;
			color: #23677B;
		}

		&.status-gray {
			background: #d6d8d9;
			color: #464747;
		}
	}
	.p-dataview-footer {
		background-color: white !important;
	}

	// Pc
	@media screen and (min-width: 750px) {
		#pcSubscriptionContainer {
			display: flex;	
		}

		#mobileSubscriptionContainer {
			display: none;	
		}
	}

	// Mobile
	@media screen and (max-width: 750px) {
		#pcSubscriptionContainer {
			display: none;	
		}

		#mobileSubscriptionContainer {
			display: block;	
		}
	}
	
</style>